import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';

export const authGuard: CanActivateFn = (route, state) => {
  const generalService = inject(GeneralService);
  const tokenService = inject(TokenService);

  if (generalService.isBrowserOnly) {
    if (tokenService.getRtk()?.length) {
      const returnUrl = route.queryParams['ru'];
      generalService.handleRedirect(returnUrl);
      return false;
    }
  }
  return true;
};
